import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {CssBaseline} from "@material-ui/core";
import {createTheme, ThemeProvider} from '@material-ui/core/styles';
import reportWebVitals from './reportWebVitals';
import AlertTemplate from './components/AlertTemplate';
import {transitions, positions, Provider as AlertProvider} from 'react-alert';
import {ConfirmProvider} from 'material-ui-confirm';

const theme = createTheme({
    typography: {
        fontFamily: [
            'Montserrat',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        h4: {
            fontWeight: 500
        }
    },
    palette: {
        type: 'dark',
        background: {
            default: '#1D2025',
            paper: '#32373D',
        },
        primary: {
            main: '#00D084',
        },
        secondary: {
            main: '#0693E3'
        },
    },
    shape: {
        borderRadius: 16,
    },
    customColors: {
        yellow: '#FAFF00',
        green: '#00D084',
        red: '#E94057',
        blue: '#0693E3'
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '*': {
                    'scrollbar-width': 'thin',
                },
                '*::-webkit-scrollbar': {
                    borderRadius: 2,
                    width: 5,
                    height: 5,
                },
                '*::-webkit-scrollbar-track': {
                    background: '#000',
                    width: 5,
                    height: 5,
                },
                '*::-webkit-scrollbar-thumb': {
                    borderRadius: 2,
                    background: '#7E848B',
                    width: 5,
                    height: 5,
                },
            }
        }
    }
});

const options = {
    position: positions.BOTTOM_CENTER,
    timeout: 5000,
    offset: '30px',
    transition: transitions.SCALE
}


ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <AlertProvider template={AlertTemplate} {...options}>
                <ConfirmProvider>
                    <CssBaseline />
                    <App />
                </ConfirmProvider>
            </AlertProvider>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
